import { useZeroBasedPricingDataSelector } from '../../../data/useSelectors';

export type ZeroBasedPricingData = {
  parPricingType?: string;
};

export const useIsZeroBasedPricing = () => {
  const zeroBased: ZeroBasedPricingData =
    useZeroBasedPricingDataSelector() as ZeroBasedPricingData;
  // false means HundredBased pricing
  if (zeroBased?.parPricingType === undefined) {
    return false;
  }
  const isZeroBasedPricing =
    zeroBased?.parPricingType.toLowerCase() === 'zerobased';
  return isZeroBasedPricing;
};
